export default __webpack_public_path__ + "static/media/challenge_2.00469098.svg";